import { Typography } from '@mui/material';
import React, { useMemo } from 'react';
import Carousel from 'components/carousel/index.jsx';
import f1 from 'assets/feedbacks/feedback01.jpg';
import f2 from 'assets/feedbacks/feedback02.jpg';
import f3 from 'assets/feedbacks/feedback03.jpg';
import f4 from 'assets/feedbacks/feedback04.jpg';
import f5 from 'assets/feedbacks/feedback05.jpg';
import f6 from 'assets/feedbacks/feedback06.jpg';
import f7 from 'assets/feedbacks/feedback07.jpg';
import f8 from 'assets/feedbacks/feedback08.jpg';

// Coloque aqui os nomes exatos dos arquivos que você tem em assets/feedbacks/
// Se suas imagens estão na pasta "public/assets/feedbacks", os paths abaixo funcionam direto.
// Se estiverem servidas pelo back, ajuste para a URL correta (o Carousel usa resolveImageUrl).
const GoogleReviewsWidget = () => {
  const items = useMemo(
    () => [
      { imageLink: f1, alt: 'Avaliação 1' },
      { imageLink: f2, alt: 'Avaliação 2' },
      { imageLink: f3, alt: 'Avaliação 3' },
      { imageLink: f4, alt: 'Avaliação 4' },
      { imageLink: f5, alt: 'Avaliação 5' },
      { imageLink: f6, alt: 'Avaliação 6' },
      { imageLink: f7, alt: 'Avaliação 7' },
      { imageLink: f8, alt: 'Avaliação 8' },
      // adicione/remova conforme seus arquivos existentes
    ],
    [],
  );

  return (
    <div style={{ marginTop: '50px' }}>
      <Typography
        variant="h5"
        sx={{
          color: '#92b21f',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          mb: 2,
          textShadow: '0 0 8px rgba(146, 178, 31, 0.6)',
        }}
      >
        A ÚNICA LOJA 5 ESTRELAS NO GOOGLE!
      </Typography>

      <div style={{ width: '100%', overflow: 'hidden' }}>
        <Carousel
          items={items}
          autoPlay interval={5000}
          fit="contain"      // mantém proporções originais
          bg="#000"       // fundo branco para “letterbox”
          aspectRatio="16/9" // mantém o layout do site igual ao resto
        />
      </div>
    </div>
  );
};

export default GoogleReviewsWidget;
